import request, { GET, POST, PUT } from '../utils/request';

const getPatientEndpoint = (patientId) =>
  `${CONFIG.API_URL}/patient/${patientId}`;

export const apiGetEmailVerificationCode = (patientId) =>
  request(POST, `${getPatientEndpoint(patientId)}/emailVerificationRequest`);

export const apiGetPhoneVerificationCode = (patientId, verificationType) =>
  request(POST, `${getPatientEndpoint(patientId)}/phoneVerificationRequest`, {
    verificationType,
  });

export const apiGetPhoneVerificationSmsStatus = (patientId) =>
  request(GET, `${getPatientEndpoint(patientId)}/phoneVerificationSmsStatus`);

export const apiGetUser = () =>
  request(GET, `${CONFIG.API_URL}/user`, {
    params: {
      deep: true,
    },
  });

export const apiLoginUser = (email, password) =>
  request(POST, `${CONFIG.API_URL}/login`, {
    email,
    password,
  });

export const apiLoginUserWithToken = (email, token) =>
  request(POST, `${CONFIG.API_URL}/loginToken`, {
    email,
    token,
  });

export const apiLogoutUser = () => request(POST, `${CONFIG.API_URL}/logout`);

export const apiSignupUserAsPatient = async (userData) => {
  const user = await request(POST, `${CONFIG.API_URL}/signup`, {
    signupType: 'patient',
    email: userData.email,
    password: userData.password,
    firstName: userData.firstName,
    lastName: userData.lastName,
    mobilePhone: userData.mobilePhone,
    gender: userData.gender,
    dateOfBirth: userData.dateOfBirth,
    settings: userData.settings,
    isAffiliate: userData.isAffiliate,
    patientSignupSource: userData.patientSignupSource,
    voglioUserId: userData.voglioUserId,
  });

  if (!user) {
    throw new Error('Failed to sign up user', { cause: user });
  }

  return user;
};

export const apiUpdatePatient = (
  patientId,
  patientDetails,
  autoVerify = false,
) =>
  request(
    PUT,
    `${getPatientEndpoint(patientId)}?autoVerify=${autoVerify}`,
    patientDetails,
  );

export const apiValidatePromoCode = (code) =>
  request(GET, `${CONFIG.API_URL}/OfferType/validatePromoCode/${code}/`);

export const apiVerifyEmail = (patientId, code) =>
  request(POST, `${getPatientEndpoint(patientId)}/emailVerification`, {
    code,
  });

export const apiVerifyPhone = (patientId, code) =>
  request(POST, `${getPatientEndpoint(patientId)}/phoneVerification`, {
    token: code,
  });
